import { ProductWorkflow } from "./productCollection";
import { IntegrationProductResource } from "./types";

export class IntegrationProduct {
    private readonly integrationProduct: IntegrationProductResource;

    constructor(product: IntegrationProductResource) {
        this.integrationProduct = product;
    }

    getId(): string {
        return this.integrationProduct.id;
    }

    getResource(): IntegrationProductResource {
        return this.integrationProduct;
    }

    getBasePrice(): number {
        if (!this.integrationProduct.product) {
            throw new Error("IntegrationProductResource does not have a product");
        }
        const basePrice = this.integrationProduct.product.basePrice || 0;
        const additionalIP = this.integrationProduct?.additionalIntegrationProduct;
        if (!additionalIP) return basePrice;
        if (additionalIP && !additionalIP.product) {
            throw new Error("An additional integration product was found, but it does not have a product");
        }
        return basePrice + (additionalIP.product!.basePrice || 0);
    }

    getDefaultWorkflow(): ProductWorkflow {
        if (!this.integrationProduct.product) {
            throw new Error("IntegrationProductResource does not have a product");
        }
        const workflows = this.integrationProduct.product.workflows || [];
        if (workflows.length === 0) {
            throw new Error(
                "No workflows found on product. This is generally due to a configuration error. Please confirm at least one workflow is configured for this product.",
            );
        }
        return new ProductWorkflow(workflows[0]);
    }

    getAllWorkflows(): ProductWorkflow[] {
        if (!this.integrationProduct.product) {
            throw new Error("IntegrationProductResource does not have a product");
        }
        const workflows = this.integrationProduct.product.workflows || [];
        if (workflows.length === 0) {
            throw new Error(
                "No workflows found on product. This is generally due to a configuration error. Please confirm at least one workflow is configured for this product.",
            );
        }
        return workflows
            .sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
            .map((workflow) => new ProductWorkflow(workflow));
    }
}
